import { useCallback, useRef } from 'react';
import { SearchInput } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { useCmdK } from '../hooks/useCmdK.js';

/**
 * Filter row for the Workspace Selector: the search field (⌘K to focus, Esc to
 * clear and blur). The sort control is slotted in via `sortControl` (CT-4939).
 */
function SelectorFilters({ query, onQueryChange, sortControl }) {
  const { t } = useTranslation('core-shell');
  const containerRef = useRef(null);

  const clear = useCallback(() => onQueryChange(''), [onQueryChange]);
  useCmdK(containerRef, { onEscape: clear });

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <div ref={containerRef} className="relative min-w-[240px] flex-1">
        <SearchInput
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          onClear={clear}
          placeholder={t('workspaceSelector.searchPlaceholder')}
          aria-label={t('workspaceSelector.searchPlaceholder')}
          // Room on the right for the keycap. SearchInput's own `pr-8` only
          // reserves space for its clear button, so without this both the
          // typed text and that button ran under the ⌘K badge.
          className="[&>input]:pr-[4.25rem]"
        />
        {/* Sits to the LEFT of SearchInput's clear button (`right-2`, 20px
            wide), not on top of it. Hidden on touch layouts, where there is no
            ⌘K to press. */}
        <span className="pointer-events-none absolute right-9 top-1/2 hidden -translate-y-1/2 rounded border border-edge bg-surface-elevated px-1.5 py-0.5 text-[10px] font-medium text-content-faint sm:block">
          ⌘K
        </span>
      </div>
      {sortControl}
    </div>
  );
}

export default SelectorFilters;
